/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import { authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';
import AppUtils from '../utilities/AppUtils';

const NotificationApi = {
  create: function createNotification() {
    return authorizedApiRequest('post', 'notifications');
  },
  del: function removeNotification(notificationId) {
    return authorizedApiRequest('delete', `notifications/${notificationId}`);
  },
  getAll: function getAllNotifications() {
    return authorizedApiRequest('get', 'notifications');
  },
  sharedOwnerResend: function sharedOwnerResendNotification(notificationId) {
    return authorizedApiRequest('put', `notifications/${notificationId}/sharedOwner/resend`);
  },
  sharedOwnerAccept: function sharedOwnerAcceptNotification(notificationId) {
    return authorizedApiRequest('put', `notifications/${notificationId}/sharedOwner/accept`);
  },
  sharedOwnerReject: function sharedOwnerRejectNotification(notificationId) {
    return authorizedApiRequest('put', `notifications/${notificationId}/sharedOwner/reject`);
  },
  count: function getNotificationsCount() {
    return authorizedApiRequest('get', 'notifications/count', () => {});
  },
};


const NotificationService = {
  create(notificationData, callback) {
    return NotificationApi.create()
    .send(_.assign({}, { subdomain: AppUtils.getSubdomain() }, notificationData))
    .end((err, res) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, res.body.data);
    });
  },
  delNotification(notificationId, callback) {
    return NotificationApi.del(notificationId)
    .end((err) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, null);
    });
  },
  getAll(callback) {
    return NotificationApi.getAll()
    .end((err, res) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, res.body.data);
    });
  },
  sharedOwnerResend(notificationId, callback) {
    return NotificationApi.sharedOwnerResend(notificationId)
    .send({ subdomain: AppUtils.getSubdomain() })
    .end((err) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, null);
    });
  },
  sharedOwnerAccept(notificationId) {
    return NotificationApi.sharedOwnerAccept(notificationId);
  },
  sharedOwnerReject(notificationId) {
    return NotificationApi.sharedOwnerReject(notificationId);
  },
  count(callback) {
    return NotificationApi.count()
    .end((err, res) => {
      if (err) {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, {});
      } else {
        callback(null, res.body.data);
      }
    });
  },
};

export default NotificationService;
